import {
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

interface NoDataProps {
  placeholderText?: string;
}
const {
  neutral: {
    background: { secondary: neutralBgSecondary },
  },
} = EquipUIFireflyV2Theme.colors;
const { paragraph } = EquipUITheme.typography;

const NoData = ({
  placeholderText = 'There is no data to show',
}: NoDataProps) => (
  <ChakraText
    {...paragraph}
    border={`2px dashed ${neutralBgSecondary}`}
    borderRadius="16px"
    color="neutral.secondary"
    marginTop="10px"
    padding="20px"
    textAlign="center"
  >
    {placeholderText}
  </ChakraText>
);

export default NoData;
